export default "__VITE_ASSET__BrsJenUy__"